import "./CreateWebshop.module.css";
import Header from "@/reusable_sections/Header";
import HeroBereich from "./sections/HeroBereich";
import Leistungen from "./sections/Leistungen";
import DemoShopMockup from "./sections/DemoShopMockup";
import WebshopFeatures from "./sections/WebshopFeatures";
import Preise from "./sections/Preise";
import ClaimsFaq from "./sections/ClaimsFaq";
import BuchungCallToAction from "./sections/BuchungCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function CreateWebshopPage() {
  return <div>
      <Header />
      <HeroBereich />
      <Leistungen />
      <DemoShopMockup />
      <WebshopFeatures />
      <Preise />
      <ClaimsFaq />
      <BuchungCallToAction />
      <Footer />
    </div>;
}